import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ButtonModule } from '@components/button/button.module';
import { HeaderMobileComponent } from './header-mobile.component';
import { ButtonGroupModule } from '@components/button-group/button-group.module';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ButtonModule,
    ButtonGroupModule
  ],
  declarations: [HeaderMobileComponent],
  exports: [HeaderMobileComponent]
})
export class HeaderMobileModule {}
